import Box from "@mui/material/Box";

function Header() {
    return (
        <div>
            <header
                className="App-header"
                style={{
                    position: "relative",
                    zIndex: "100",
                    width: "100%",
                    justifyContent: "center",
                    display: "flex",
                }}
            >
                <Box
                    xs="1"
                    component="img"
                    style={{
                        height: "9vh",
                        padding: "2vh 0rem",
                    }}
                    alt="HD+ logo"
                    src="HDplus-Logo.svg"
                />
            </header>
        </div>
    );
}

export default Header;
